var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3889)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.4209H5.7294V14.1375H4.08665V18.2652H1.69815V14.1375H0V12.4209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63352 14.782L7.42543 18.2655H5.13281L7.38281 12.4211H9.87145L12.1747 18.2655H9.8544L8.63352 14.782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6274 12.4211H17.359V14.1377H15.7141V18.2655H13.3277V14.1377H11.6274V12.4211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2605 14.782L19.0545 18.2655H16.7598L19.0098 12.4211H21.5005L23.8017 18.2655H21.4814L20.2605 14.782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08381 31.8634H0V23.5156C0 21.969 0.852273 21.1191 2.27983 21.1191C3.29403 21.1191 3.94602 21.5388 4.58523 23.0078L7.32315 29.3998C7.40625 29.5908 7.48935 29.66 7.62997 29.66C7.66866 29.664 7.70777 29.6592 7.74427 29.646C7.78077 29.6327 7.81369 29.6114 7.84047 29.5836C7.86725 29.5558 7.88717 29.5223 7.8987 29.4857C7.91023 29.4491 7.91306 29.4104 7.90696 29.3725V21.1947H10.0142V29.5425C10.0142 31.0891 9.19389 31.939 7.77699 31.939C6.76278 31.939 6.04048 31.5004 5.41406 30.0503L2.66761 23.652C2.58452 23.4611 2.50142 23.3918 2.36293 23.3918C2.32407 23.3874 2.28471 23.392 2.24794 23.4051C2.21116 23.4182 2.17796 23.4395 2.15093 23.4673C2.1239 23.4952 2.10378 23.5288 2.09213 23.5656C2.08049 23.6023 2.07764 23.6413 2.08381 23.6793V31.8634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7342 31.8633H13.7214C12.5815 31.8633 11.9146 31.2065 11.9146 30.0838V22.9678C11.9146 21.8451 12.5815 21.1882 13.7214 21.1882H19.7384V23.2133H14.4714C14.4168 23.2078 14.3618 23.2143 14.3101 23.2322C14.2583 23.2501 14.2113 23.2791 14.1722 23.3169C14.1332 23.3548 14.1031 23.4007 14.0841 23.4513C14.065 23.502 14.0576 23.5561 14.0623 23.6099V25.4167H19.4614V27.3872H14.0623V29.4416C14.0578 29.4948 14.0651 29.5484 14.0837 29.5985C14.1023 29.6487 14.1319 29.6942 14.1702 29.732C14.2085 29.7697 14.2548 29.7988 14.3057 29.8171C14.3566 29.8355 14.411 29.8427 14.465 29.8382H19.7278L19.7342 31.8633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6479 21.1946H23.8021V27.6412C23.8021 29.0094 24.844 29.981 26.263 29.981C27.682 29.981 28.7218 29.0094 28.7218 27.6412V21.1946H30.8759V27.6412C30.8759 30.172 28.9434 32.006 26.263 32.006C23.5826 32.006 21.6479 30.172 21.6479 27.6412V21.1946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8594 4.91243C33.0374 4.62027 33.131 4.28575 33.13 3.94502C33.1475 3.49304 32.9996 3.04991 32.7134 2.69619C32.4272 2.34247 32.0216 2.10167 31.5704 2.01756C31.1191 1.93346 30.6522 2.01163 30.2546 2.23788C29.8569 2.46413 29.5549 2.82342 29.4035 3.25042L25.2167 13.4554C25.1534 13.5866 25.1199 13.7299 25.1187 13.8751C25.1228 14.0954 25.199 14.3085 25.3361 14.4826C25.4732 14.6568 25.6638 14.7826 25.8794 14.8413C26.0951 14.9001 26.3242 14.8886 26.5327 14.8087C26.7411 14.7287 26.9178 14.5845 27.0363 14.3976L32.8594 4.91243Z",
    fill: "url(#paint0_linear_1_3889)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3201 4.35624C29.2346 3.99075 29.2659 3.60815 29.4096 3.26083C29.552 2.88546 29.8118 2.56441 30.1516 2.34409C30.4915 2.12377 30.8936 2.0156 31.3 2.03523C31.7063 2.05485 32.0958 2.20125 32.4121 2.45326C32.7284 2.70527 32.9551 3.04982 33.0595 3.4371L37.1333 16.2065C37.3138 16.7242 37.3331 17.2832 37.1887 17.8118C37.023 18.424 36.6495 18.9618 36.1304 19.3359C35.6112 19.7101 34.9777 19.8979 34.3352 19.8682C33.6926 19.8385 33.0797 19.5932 32.5984 19.1729C32.1171 18.7525 31.7963 18.1826 31.6895 17.5579L29.3201 4.35624Z",
    fill: "url(#paint1_linear_1_3889)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5119 5.45604C44.8849 4.81491 45.0506 4.07703 44.987 3.34076C44.9157 2.52401 44.5676 1.75461 43.9986 1.15629C43.4296 0.557965 42.6729 0.165485 41.8501 0.0419635C41.0272 -0.0815584 40.1861 0.0710555 39.462 0.475264C38.7379 0.879472 38.1729 1.51179 37.8577 2.27052L31.8918 15.9632C31.6012 16.6194 31.5792 17.3608 31.8304 18.0326C32.0816 18.7044 32.5865 19.2546 33.2398 19.5685C33.8931 19.8823 34.6442 19.9355 35.3364 19.7169C36.0285 19.4983 36.6082 19.0249 36.9543 18.3954L44.5119 5.45604Z",
    fill: "url(#paint2_linear_1_3889)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3889",
    x1: 25.7046,
    y1: 14.8027,
    x2: 31.909,
    y2: 2.16981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0096FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1680FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#4D49FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#7521FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#8D09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9600FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_3889",
    x1: 30.411,
    y1: 2.1864,
    x2: 35.0624,
    y2: 19.8135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#9600FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B600DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DE00B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F6009F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF0096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_3889",
    x1: 33.2235,
    y1: 19.5873,
    x2: 42.7089,
    y2: 0.270768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF0096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FF1680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF4D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF7521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF8D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF9600"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.eb0ae1f4b09ffd56fa7924e9dc0d6d83.svg";
export { ForwardRef as ReactComponent };